/* PTB v16 — interactions générales, sans gestion des variantes produit */
(function () {
  "use strict";

  var burger = document.querySelector("[data-ptb-burger]");
  var drawer = document.querySelector("[data-ptb-drawer]");
  if (burger && drawer) {
    function closeDrawer() {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      burger.setAttribute("aria-expanded", "false");
    }
    burger.addEventListener("click", function () {
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      burger.setAttribute("aria-expanded", "true");
      var first = drawer.querySelector("a, button");
      if (first) first.focus();
    });
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-ptb-drawer-close]")) closeDrawer();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });
  }

  function syncHeaderBottom() {
    var header = document.querySelector("[data-ptb-header]");
    if (header) {
      document.documentElement.style.setProperty(
        "--ptb-header-bottom",
        header.getBoundingClientRect().bottom + "px"
      );
    }
  }
  syncHeaderBottom();
  window.addEventListener("resize", syncHeaderBottom);
  window.addEventListener("scroll", syncHeaderBottom, { passive: true });

  document.querySelectorAll("[data-ptb-mobile-toggle]").forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      var group = toggle.closest("[data-ptb-mobile-group]");
      var panel = group && group.querySelector(".drawer__submenu");
      if (!panel) return;
      var open = toggle.getAttribute("aria-expanded") === "true";
      document.querySelectorAll("[data-ptb-mobile-toggle]").forEach(function (other) {
        var g = other.closest("[data-ptb-mobile-group]");
        var p = g && g.querySelector(".drawer__submenu");
        other.setAttribute("aria-expanded", "false");
        if (p) p.hidden = true;
      });
      toggle.setAttribute("aria-expanded", open ? "false" : "true");
      panel.hidden = open;
    });
  });

  var toasts = document.getElementById("ptb-toasts");
  var isEnglish = (document.documentElement.lang || "").toLowerCase().indexOf("en") === 0;
  function toast(title, sub) {
    if (!toasts) return;
    var el = document.createElement("div");
    el.className = "toast";
    el.innerHTML = "<b></b><span></span>";
    el.querySelector("b").textContent = title;
    el.querySelector("span").textContent = sub || "";
    toasts.appendChild(el);
    window.setTimeout(function () { el.remove(); }, 3500);
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest("form[data-ptb-quick-add]");
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector("[type=submit]");
    var input = form.querySelector("[name=id]");
    if (!input) return;
    if (btn) btn.disabled = true;
    fetch((window.PTB && window.PTB.cartAddUrl) || "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: Number(input.value), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error("cart"); return r.json(); })
      .then(function (item) {
        toast(isEnglish ? "Added to cart" : "Ajouté au panier", item.product_title || "");
        return fetch("/cart.js").then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll("[data-ptb-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {
        toast(isEnglish ? "Oops" : "Oups", isEnglish ? "Unable to add this item." : "Impossible d'ajouter cet article.");
      })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  document.querySelectorAll("[data-ptb-countdown]").forEach(function (root) {
    var attr = root.getAttribute("data-deadline");
    var target;
    if (attr) {
      target = new Date(attr).getTime();
    } else {
      var d = new Date();
      d.setDate(d.getDate() + (((7 - d.getDay()) % 7) || 7));
      d.setHours(20, 0, 0, 0);
      target = d.getTime();
    }
    var cells = {
      j: root.querySelector("[data-j]"),
      h: root.querySelector("[data-h]"),
      m: root.querySelector("[data-m]"),
      s: root.querySelector("[data-s]")
    };
    function pad(n) { return String(n).padStart(2, "0"); }
    function tick() {
      var seconds = Math.max(0, Math.floor((target - Date.now()) / 1000));
      if (cells.j) cells.j.textContent = pad(Math.floor(seconds / 86400));
      if (cells.h) cells.h.textContent = pad(Math.floor((seconds % 86400) / 3600));
      if (cells.m) cells.m.textContent = pad(Math.floor((seconds % 3600) / 60));
      if (cells.s) cells.s.textContent = pad(seconds % 60);
    }
    tick();
    window.setInterval(tick, 1000);
  });

  var sortSelect = document.querySelector("[data-ptb-sort]");
  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sortSelect.value);
      window.location.href = url.toString();
    });
  }
})();
